module.exports = __webpack_public_path__ + "static/media/3.23e11d5d.svg";